import { CraneShift } from "src/store/api/generatedApi";

const CACHE_KEY_PREFIX = "shifts_cache_";
const CACHE_EXPIRY_MS = 2 * 24 * 60 * 60 * 1000; // 2 days

interface CachedShiftsData {
  shifts: CraneShift[];
  timestamp: number;
}

const getCacheKey = (tenant: string): string => `${CACHE_KEY_PREFIX}${tenant}`;

export const loadShiftsFromCache = (tenant: string): CraneShift[] | null => {
  try {
    const key = getCacheKey(tenant);
    const stored = localStorage.getItem(key);
    if (!stored) return null;

    const parsed = JSON.parse(stored) as CachedShiftsData;
    const now = Date.now();

    if (now - parsed.timestamp > CACHE_EXPIRY_MS) {
      localStorage.removeItem(key);
      return null;
    }

    return parsed.shifts;
  } catch {
    return null;
  }
};

export const saveShiftsToCache = (
  tenant: string,
  shifts: CraneShift[]
): void => {
  try {
    const key = getCacheKey(tenant);
    const data: CachedShiftsData = {
      shifts,
      timestamp: Date.now(),
    };
    localStorage.setItem(key, JSON.stringify(data));
  } catch {
    // localStorage may be full or disabled - fail silently
  }
};
